import {Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {DatepickerOptions} from 'ng2-datepicker';
//import * as frLocale from 'date-fns/locale/fr';

import {SurveyService} from './../../surveys.service';
import {PeopleService} from './../../../people/people.service';
import {SurveyCreatePDModel} from './../../../../models/survey/survey.model';
import {DataTransferService} from './../../../../shared/services/data-transfer.service';
import {
  PeopleSearchPDModel,
  PeopleFilterModel,
  PeopleModel,
  SelectedPeoplesToSurvey
} from './../../../../models/people/people.model';
import {DropdownComponent} from './../../../../shared/components/dropdown/dropdown.component';

@Component({
  selector: 'app-people-tab',
  templateUrl: './people-tab.component.html',
  styleUrls: ['./people-tab.component.less']
})
export class PeopleTabComponent implements OnInit, OnDestroy {

  filter: boolean;
  people: Array<any>;
  column: string;
  isDesc: boolean;
  date: string;
  dropdownLabel: string;
  location: string[];
  gender: string[];
  peopleFilter: PeopleFilterModel;

  // surveyCreatePDModel: SurveyCreatePDModel;
  @Input() surveyCreatePDModel: SurveyCreatePDModel;
  @Output() surveyCreatePDModelChange = new EventEmitter<SurveyCreatePDModel>();

  @ViewChild('ddSource') ddSource: DropdownComponent;
  @ViewChild('ddSurvey') ddSurvey: DropdownComponent;
  @ViewChild('ddLocation') ddLocation: DropdownComponent;
  @ViewChild('ddGender') ddGender: DropdownComponent;

  constructor(private surveyService: SurveyService, private peopleService: PeopleService) {
  }

  ngOnInit() {

    this.filter = false;
    this.column = 'lastName';
    this.isDesc = false;
    this.date = new Date().toDateString();
    this.dropdownLabel = 'Select';
    this.gender = ['Male', 'Female'];

    this.initFilter();
  }

  ngOnDestroy() {
    this.surveyCreatePDModelChange.emit(this.surveyCreatePDModel);
  }

  search() {
    if (this.peopleFilter.city == 'Any') {
      this.peopleFilter.city = null;
    }
    if (this.peopleFilter.genderId == 'Any') {
      this.peopleFilter.genderId = null;
    }
    this.peopleService.filterPeopleCount(this.peopleFilter).subscribe(
      (response) => {
        // append values
        this.surveyCreatePDModel.totalSelectedPeopleCount = response;
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  resetFilter() {
    this.ddSource.dropdownLabel = "Select";
    this.ddSurvey.dropdownLabel = "Select";
    this.ddLocation.dropdownLabel = "Select";
    this.ddGender.dropdownLabel = "Select";
    this.initFilter();
  }


  openFilter() {
    this.filter = true;
  }

  initFilter() {
    this.peopleFilter = {
      filterOn: true,
      dateLastInteraction: new Date().toString(),
      city: null,
      ageFrom: 0,
      ageTo: 0,
      genderId: null,
      surveyId: null,
      sourceId: null
    }
  }

  updateFilter(e: any, filed: string) {
    switch (filed) {
      case 'source' :
        this.peopleFilter.sourceId = e.id;
        break;
      case 'location' :
        this.peopleFilter.city = e;
        break;
      case 'gender' :
        this.peopleFilter.genderId = e.id;
        break;
      case 'survey' :
        this.peopleFilter.surveyId = e.id;
        break;
    }
  }


}





// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/people-tab/people-tab.component.ts